/**
 * A utility to convert a string to an html id attribute safe string
 * e.g. 'My card component!' becomes 'my-card-component'
 * Credit: https://inclusive-components.design/cards/
 */
var slugify = function slugify(text) {
  return text.toString().toLowerCase().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
};

export { slugify };
